var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_190_481)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 80,
    height: 80,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 14.5,
    stroke: "#EEEEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8421 34.7895L59.8947 30.7895C59.5263 27.4211 56.6842 24.7895 53.2632 24.7895H53.2105V20.3684C53.2105 20 53 19.6316 52.6842 19.4211L45.2105 15.1579C44.8947 14.9474 44.4737 14.9474 44.1579 15.1579L36.6842 19.4737C36.3684 19.6842 36.1579 20 36.1579 20.4211V24.8421H36.1053C32.6316 24.8421 29.7895 27.4737 29.4737 30.8421L22.5263 34.7895C22.2105 35 22 35.3158 22 35.7368V44.3158C22 44.6842 22.2105 45.0526 22.5263 45.2632L29.4737 49.2632C29.8421 52.5789 32.6842 55.2632 36.1579 55.2632H36.2105V59.6842C36.2105 60.0526 36.4211 60.4211 36.7368 60.6316L44.1579 64.8421C44.3158 64.9474 44.5263 65 44.6842 65C44.8421 65 45.0526 64.9474 45.2105 64.8421L52.6842 60.5263C53 60.3158 53.2105 60 53.2105 59.5789V55.2632H53.2632C56.7368 55.2632 59.5789 52.6316 59.8947 49.2632L66.8421 45.2632C67.1579 45.0526 67.3684 44.7368 67.3684 44.3158V35.6842C67.3684 35.3158 67.1579 34.9474 66.8421 34.7895ZM52.4737 37.5263L57.7895 40.5789V46.7368L52.4737 43.6842V37.5263ZM58.8421 38.7895L53.5263 35.7368L58.8421 32.6316L64.1579 35.6842L58.8421 38.7895ZM38.3158 22.2105L43.6316 25.2632V31.4211L38.3158 28.3684V22.2105ZM45.7368 25.2632L51.0526 22.2105V28.3684L45.7368 31.4211V25.2632ZM44.6842 17.3158L50 20.3684L44.6842 23.4211L39.3684 20.3684L44.6842 17.3158ZM31.5789 46.7368V40.6316L36.8947 37.5789V43.6842L31.5789 46.7368ZM30.5263 38.7895L25.2105 35.6842L30.5263 32.6316L35.8421 35.6842L30.5263 38.7895ZM24.1579 37.5263L29.4737 40.5789V46.7368L24.1579 43.6842V37.5263ZM44.6842 54.1053L39.3684 51.0526L44.6842 47.9474L50 51.0526L44.6842 54.1053ZM38.3158 52.8947L43.6316 55.9474V62.1053L38.3158 59.0526V52.8947ZM45.7368 62.1053V55.9474L51.0526 52.8947V59.0526L45.7368 62.1053ZM53.2105 53.1053V51.0526C53.2105 50.6842 53 50.3158 52.6842 50.1053L45.2105 45.7895C44.8947 45.5789 44.4737 45.5789 44.1579 45.7895L36.6842 50.1053C36.3684 50.3158 36.1579 50.6316 36.1579 51.0526V53.1053H36.1053C33.7895 53.1053 31.8947 51.4211 31.5789 49.2105L38.4211 45.2632C38.7368 45.0526 38.9474 44.7368 38.9474 44.3158V35.6842C38.9474 35.3158 38.7368 34.9474 38.4211 34.7368L31.5789 30.7895C31.8947 28.5789 33.7895 26.8947 36.1053 26.8947H36.1579V28.9474C36.1579 29.3158 36.3684 29.6842 36.6842 29.8947L44.1579 34.2105C44.3158 34.3158 44.5263 34.3684 44.6842 34.3684C44.8421 34.3684 45.0526 34.3158 45.2105 34.2105L52.6842 29.8947C53 29.6842 53.2105 29.3684 53.2105 28.9474V26.8947H53.2632C55.5789 26.8947 57.4211 28.5789 57.7368 30.7895L50.8947 34.7368C50.5789 34.9474 50.3684 35.2632 50.3684 35.6842V44.2632C50.3684 44.6316 50.5789 45 50.8947 45.2105L57.7368 49.1579C57.4211 51.4211 55.5263 53.1053 53.2105 53.1053ZM59.8947 46.7368V40.6316L65.2105 37.5263V43.6842L59.8947 46.7368Z",
    fill: "#3D63C3",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_190_481",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_190_481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_190_481",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.ae8b62f6153bfe7c75efc67fcae3b01f.svg";
export { ForwardRef as ReactComponent };